import { Component, Inject } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { LogoutService } from './logout.service';
import { MatDialog } from "@angular/material";

@Component({
    template: '',
    providers: [LogoutService],
    preserveWhitespaces: true
})

export class LogoutComponent implements OnInit {
    private _errorMessage: any = {};
    subjectChangeSubscribeFlag: boolean;

    constructor(
        private _logoutService: LogoutService,
        private _router: Router,
        public dialog: MatDialog,
        @Inject('utilService') private utilService: any
    ) {
        this.utilService.LogoutChatConfirm.subscribe(this.confirmLogout);
    }

    confirmLogout = (confirmDetails: any) => {
        if (confirmDetails.confirm && this.subjectChangeSubscribeFlag) {
            this.subjectChangeSubscribeFlag = false;
            this._logoutService.logout().
                subscribe((res: any) => this.logoutSuccessHandler(res),
                    error => this.logoutError(error));
        }
    }

    /**
     * Function to logout
     */
    logout() {
        this.utilService.userLogout.next({ logOut: true });
    }

    /**
     * function invoked for logout success.
     * @param  {any} res contains api response.
     */
    logoutSuccessHandler = async (res: any) => {
        sessionStorage.removeItem('logined');
        await this._logoutService.clearStorage();
        this.utilService.defaultRoleChange.next({update: true});
        this.utilService.setUserLoggedIn(false);
        this._router.navigate(['/login'], { replaceUrl: true });
    }

    /**
     * funtion invoked for logout failure.
     * @param  {any} error contains api error response.
     */
    logoutError = async (error: any) => {
        await this._logoutService.clearStorage();
        this._router.navigate(['/login'], { replaceUrl: true });
    }

    ngOnInit() {
        this.subjectChangeSubscribeFlag = true;
        this.dialog.closeAll();
        this.logout();
    }
}
